<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jiPfPu/tc-custom/9783958646087_IMGJPG_FrontCover_0.jpg?1703042359909" alt="This image is the cover for the book The Brethren, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Brethren, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Sir Henry Rider Haggard was an English writer of adventure novels set in exotic locations, predominantly Africa, and the creator of the Lost World literary genre. His stories, situated at the lighter end of the scale of Victorian literature, continue to be popular and influential. He was also involved in agricultural reform and improvement in the British Empire. This novel is about adventure, bravery, love, war. Two brave knight brothers love their cousin Rosamund. Suddenly Rosamund got kidnapped and the knights start their journey to save them! (Excerpt from Goodreads)</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        H. Rider Haggard
      </h2>
      
      <p class="authorDescription body article">Sir Henry Rider Haggard was an English writer of adventure novels set in exotic locations, predominantly Africa, and the creator of the Lost World literary genre. His stories, situated at the lighter end of the scale of Victorian literature, continue to be popular and influential. He was also involved in agricultural reform and improvement in the British Empire. “When the World Shook” is a novel by H. Rider Haggard written in 1919. It deals with the adventures of Bastin, Bickley, and Arbuthnot as they travel to the south sea island of Orofena The story begins as the main character, Humphrey Arbuthnot—a writer of adventure stories—is married to his wife Natalie. Shortly there after she claims that she is going to die soon even after she has been given a clean bill of health from their doctor, Bastin. Right as Natalie dies she tells Arbuthnot that shortly after she dies he'll want to travel somewhere and that is where the two shall meet again. Natalie dies, and shortly there after Arbuthnot has a sudden urge to travel to the Pacific islands. He gets on a ship with two friends, Bickley, a doctor, Bastin, a minister, and Arbuthnot's dog, Tommy. The ship is then taken by a cyclone after all the crew abandons ship save for the three adventurers. When they awake they find themselves shipwrecked on the south sea island of Orofena.(Excerpt from Wikipedia)</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?860d697e